import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/(redirects)/links')({
  beforeLoad: () => {
    throw redirect({ to: '/resources', replace: true });
  },
})
